import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import WSCBlazeLiveContentBlockLayout from './wsc-blaze-live-content-block-layout.js';

class WSCBlazeLiveContentBlockComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        ReactDOM.render(
            <WSCBlazeLiveContentBlockLayout options={this.options} />,
            this.element
        );
    }
}

export default WSCBlazeLiveContentBlockComponent;
